// Current client identity binding for quick-login routing.
//
// IMPORTANT:
// - This is NOT an authentication secret and never contains a password, MPIN or session token.
// - The opaque deviceIdentityCredential can only select the server-bound identity for OTP;
//   OTP verification is still required before a session can be issued.
// - Native WebView storage is used deliberately so a device/OEM Keystore failure cannot
//   block normal User ID + Password login.
// - Server-side client_device_identity_credentials remains authoritative.
const KEY = "mfsetu_client_current_identity_v2";
const LEGACY_WEB_KEY = "mfsetu_client_current_identity_web_v1";

const normalize = (value) => ({
  deviceIdentityCredential: String(value?.deviceIdentityCredential || ""),
  userId: String(value?.userId || "").trim().toUpperCase(),
  displayName: String(value?.displayName || ""),
});

export const readClientIdentity = async () => {
  try {
    const raw = localStorage.getItem(KEY) || localStorage.getItem(LEGACY_WEB_KEY);
    if (!raw) return null;
    const parsed = normalize(JSON.parse(raw));
    return parsed.deviceIdentityCredential && parsed.userId ? parsed : null;
  } catch {
    return null;
  }
};

export const saveClientIdentity = async (value) => {
  const clean = normalize(value);
  if (!clean.deviceIdentityCredential || !clean.userId) {
    throw new Error("Current login identity is incomplete.");
  }
  localStorage.setItem(KEY, JSON.stringify(clean));
  // Keep the remembered identity aligned with the last successful password login.
  localStorage.setItem("mfsetu_client_remembered_user_id", clean.userId);
};

export const clearClientIdentity = async () => {
  localStorage.removeItem(KEY);
  localStorage.removeItem(LEGACY_WEB_KEY);
};
